"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IPartialResult.js.map